(function () {
  "use strict";

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var area = document.createElement("textarea");
      area.value = value; area.readOnly = true;
      area.style.cssText = "position:fixed;opacity:0;pointer-events:none";
      document.body.appendChild(area); area.select();
      try { document.execCommand("copy") ? resolve() : reject(); } catch (e) { reject(e); }
      area.remove();
    });
  }

  function bindSkuCopy(root) {
    (root || document).querySelectorAll("[data-smpc-copy-sku]").forEach(function (button) {
      if (button.dataset.smpcBound) return;
      button.dataset.smpcBound = "1";
      button.addEventListener("click", function () {
        var status = button.closest(".smpc2__sku").querySelector("[data-smpc-copy-status]");
        copyText(button.dataset.smpcCopySku || button.textContent.trim()).then(function () {
          status.textContent = "Copied";
          setTimeout(function () { status.textContent = ""; }, 1500);
        });
      });
    });
  }

  function nextBusinessDay(date) {
    var d = new Date(date);
    do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
    return d;
  }
  function pad(n) { return String(n).padStart(2, "0"); }
  function deliveryTarget(now, cutoffHour) {
    var cutoff = new Date(now); cutoff.setHours(cutoffHour, 0, 0, 0);
    var weekday = now.getDay();
    if (weekday >= 1 && weekday <= 4 && now < cutoff) return { cutoff: cutoff, date: nextBusinessDay(now) };
    var start = new Date(now);
    if (weekday === 5 && now < cutoff) return { cutoff: cutoff, date: nextBusinessDay(now) };
    do { start.setDate(start.getDate() + 1); } while (start.getDay() === 0 || start.getDay() === 6);
    start.setHours(cutoffHour, 0, 0, 0);
    return { cutoff: start, date: nextBusinessDay(start) };
  }
  function formatDate(d) {
    return d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "short" });
  }
  function updateDelivery(card) {
    var output = card.querySelector("[data-smpc-delivery-message]");
    if (!output) return;
    var now = new Date(), result = deliveryTarget(now, Number(card.dataset.cutoffHour || 15));
    var seconds = Math.max(0, Math.floor((result.cutoff - now) / 1000));
    var h = Math.floor(seconds / 3600), m = Math.floor((seconds % 3600) / 60), s = seconds % 60;
    var text = "Order within " + pad(h) + "h " + pad(m) + "m " + pad(s) + "s for delivery by " + formatDate(result.date) + ".";
    if (output.textContent !== text) output.textContent = text;
  }
  function bindDelivery(root) {
    (root || document).querySelectorAll("[data-smpc-delivery]").forEach(function (card) {
      if (card.dataset.smpcTimer) return;
      card.dataset.smpcTimer = "1";
      updateDelivery(card);
      card._smpcTimer = setInterval(function () { updateDelivery(card); }, 1000);
    });
  }
  function init(root) { bindSkuCopy(root); bindDelivery(root); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); }); else init(document);
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
